module.exports = __webpack_public_path__ + "static/media/037.c3c4aaa6.jpg";